module.exports = __webpack_public_path__ + "img/swqr.6c17fa9a.png";